import { $t } from '@/i18n';
export const CATEGORY = {
  UI: $t('k_932ce511'),
  LOGIC: $t('k_f5254608'),
  DATASOURCE: $t('k_ccd9cc09'),
  EXPORT: $t('k_7b36b47a'),
  NAVIGATOR: $t('k_ff744567'),
  DRAFT: $t('k_3960fc20'),
  NOTIFICATION: $t('k_4c349cd3'),
  WORKFLOW: $t('k_3e0d1f1f'),
  FLOW: $t('k_cecdb728'),
  AI: $t('k_2862e786'),
};
